module.exports = __webpack_public_path__ + "images/8cf19b8a2495b490532104edabe6df7f-logo_white.png";